import { isObject, partial } from 'underscore';

const invalidForAppend = (value) => [null, undefined].includes(value);

const append = (url, key, value) => {
  if (invalidForAppend(value)) { return; }

  if (Array.isArray(value)) {
    value.forEach(partial(append, url, `${key}[]`));
  } else if (isObject(value)) {
    Object.entries(value).forEach(([keyIn, valueIn]) => append(url, `${key}[${keyIn}]`, valueIn));
  } else {
    url.searchParams.append(key, value);
  }
};

export const appendParamsToUrl = (url, params) => {
  const appendToUrl = partial(append, url);

  Object.entries(params).forEach(([key, value]) => appendToUrl(key, value));

  return url;
};

export default {
  appendParamsToUrl,
};
